module.exports = __webpack_public_path__ + "img/contribute_0.92098d03.png";